const RECOMM_CACHE = {};

const getRecommendationCarousels = () => document.querySelectorAll('[id^="cq_recomm_slot"]');

export const persistRecommendations = () => {
  getRecommendationCarousels().forEach((carousel) => {
    RECOMM_CACHE[carousel.id] = carousel.innerHTML;
  });
};

export const restoreRecommendations = (restoredCallback) => {
  let carouselRestored = false;

  getRecommendationCarousels().forEach((carousel) => {
    if (RECOMM_CACHE[carousel.id]) {
      carousel.innerHTML = RECOMM_CACHE[carousel.id];

      carouselRestored = true;
      delete RECOMM_CACHE[carousel.id];
    }
  });

  if (carouselRestored && typeof restoredCallback === 'function') {
    restoredCallback();
  }
};
